// extracted by mini-css-extract-plugin
module.exports = {"circle":"whiteCircle_circle__cWgjr","active":"whiteCircle_active__q4prm"};